import React, { useEffect } from "react";

const CustomLoader = () => {
  useEffect(() => {
    // Add the 'loaded' class when window finishes loading
    const handleLoad = () => {
      const preloader = document.getElementById("preloader");
      if (preloader) {
        preloader.classList.add("loaded");
      }
    };
    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <>
      <style>{`
        #preloader {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: #000000;
          opacity: 0.5;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
          transition: opacity 0.6s ease, visibility 0.6s ease;
        }

        #preloader.loaded {
          opacity: 0;
          visibility: hidden;
        }

        .neon-spinner {
          width: 80px;
          height: 80px;
          border: 6px solid rgba(0, 255, 0, 0.2);
          border-top-color: #00ff00;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          box-shadow: 0 0 15px #00ff00, 0 0 30px #00ff0055;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <div id="preloader">
        <div className="neon-spinner"></div>
      </div>
    </>
  );
};

export default CustomLoader;
